import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['card', 'chip'];

  static values = {
    tag: { type: String, default: '' },
    difficulty: { type: String, default: '' },
  };

  connect() {
    this.applyFilters();
  }

  selectTag(event) {
    const tag = event.currentTarget.dataset.quizHubTagParam || '';
    this.tagValue = this.tagValue === tag ? '' : tag;
    this.applyFilters();
    this.updateChipStates('tag', this.tagValue);
  }

  selectDifficulty(event) {
    const difficulty = event.currentTarget.dataset.quizHubDifficultyParam || '';
    this.difficultyValue = this.difficultyValue === difficulty ? '' : difficulty;
    this.applyFilters();
    this.updateChipStates('difficulty', this.difficultyValue);
  }

  clearFilters() {
    this.tagValue = '';
    this.difficultyValue = '';
    this.applyFilters();
    this.updateChipStates('tag', '');
    this.updateChipStates('difficulty', '');
  }

  applyFilters() {
    this.cardTargets.forEach((card) => {
      const matchesTag = !this.tagValue || card.dataset.tags?.split(',').includes(this.tagValue);
      const matchesDifficulty = !this.difficultyValue || card.dataset.difficulty === this.difficultyValue;
      card.hidden = !(matchesTag && matchesDifficulty);
    });
  }

  updateChipStates(kind, activeValue) {
    this.chipTargets
      .filter((chip) => chip.dataset.chipKind === kind)
      .forEach((chip) => {
        const value = chip.dataset.chipValue || '';
        const active = value === activeValue && activeValue !== '';
        chip.classList.toggle('quiz-hub-chip--active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
  }
}
